import "core-js/modules/esnext.global-this.js";
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var __assign = commonjsGlobal && commonjsGlobal.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

function parse(cookieString) {
  var result = {};
  var cookies = cookieString ? cookieString.split('; ') : [];
  var rdecode = /(%[\dA-F]{2})+/gi;

  for (var i = 0; i < cookies.length; i++) {
    var parts = cookies[i].split('=');
    var cookie = parts.slice(1).join('=');

    if (cookie.charAt(0) === '"') {
      cookie = cookie.slice(1, -1);
    }

    try {
      var name_1 = parts[0].replace(rdecode, decodeURIComponent);
      result[name_1] = cookie.replace(rdecode, decodeURIComponent);
    } catch (e) {// ignore cookies with invalid name/value encoding
    }
  }

  return result;
}

function getAll() {
  return parse(document.cookie);
}

function get(name) {
  return getAll()[name];
}

var get_1 = get;
var COOKIE_NAME = "puc-ab";
var CONTEXT_COOKIE_NAME = "userContext";

var getAllExperiments = function getAllExperiments() {
  try {
    var contextCookie = get_1(CONTEXT_COOKIE_NAME);

    if (contextCookie) {
      return deserializeFromContext(contextCookie);
    }

    var rawCookie = get_1(COOKIE_NAME);

    if (rawCookie) {
      return deserialize(rawCookie, ",");
    }
  } catch (e) {
    console.warn("Experiment variation reader in getAllExperiments failed.", e);
    return [];
  }

  return [];
};

var getVariation = function getVariation(experimentKey) {
  try {
    var experiments = getAllExperiments();
    var experiment = experiments.find(function (e) {
      return e.experimentKey === experimentKey;
    });
    return experiment ? experiment.variationKey : null;
  } catch (e) {
    console.warn("Experiment variation reader in getVariation failed.", e);
    return null;
  }
};

var isAvailable = function isAvailable() {
  try {
    var cookie = get_1(COOKIE_NAME);
    return cookie !== undefined && cookie !== null && cookie !== "";
  } catch (e) {
    console.warn("Experiment variation reader in isAvailable failed.", e);
    return false;
  }
};

var whenAvailable = function whenAvailable(callback) {
  var handler = function handler() {
    window.removeEventListener("variationsResolved", handler);
    callback();
  };

  if (isAvailable()) {
    callback();
  } else {
    window.addEventListener("variationsResolved", handler);
  }
};

var deserialize = function deserialize(rawCookie, splitter) {
  var rawExperiments = rawCookie.split(splitter);
  var experiments = [];
  rawExperiments.forEach(function (experiment) {
    var experimentData = experiment.split(":");
    var isValidKey = true;

    if (experimentData.length != 2) {
      console.warn("Experiment cookie is malformed: ", rawCookie);
      isValidKey = false;
    }

    var experimentKey = experimentData[0].trim();

    if (experiments.some(function (e) {
      return e.experimentKey === experimentKey;
    })) {
      console.warn("Experiment cookie has more than one instance of experiment key ".concat(experimentKey), rawCookie);
      isValidKey = false;
    }

    if (isValidKey) {
      experiments.push({
        experimentKey: experimentKey,
        variationKey: experimentData[1].trim()
      });
    }
  });
  return experiments;
};

var deserializeFromContext = function deserializeFromContext(contextCookieValue) {
  var _a;

  var contextValue = JSON.parse(decodeURIComponent(contextCookieValue));
  var experiments = (_a = contextValue === null || contextValue === void 0 ? void 0 : contextValue.experiments) === null || _a === void 0 ? void 0 : _a.v1;

  if (experiments) {
    return Object.keys(experiments).map(function (e) {
      return {
        experimentKey: e,
        variationKey: experiments[e]
      };
    });
  }

  return [];
};

export { getAllExperiments, getVariation, isAvailable, whenAvailable };